﻿import { Component, ViewChild  } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { DataService } from "../services/dataService";
import { ValidationMessage } from "../validation/validationMessage";
import { ValidationMessageType } from "../validation/validationMessageType";
import {CaseType} from '../models/Enums';

@Component({
    selector: "jax-casededtailmaincomponent",
    templateUrl: "./caseDetailMain.component.html",
})
export class CaseDetailMainComponent {

    public caseNumber: string;
    public caseId: number;
    public roleId: number;
    public CaseType:string;
    public sub: any;
    public isCaseRestricted: boolean;
    public currentUser: any;
    public validationMessage: ValidationMessage;
    public IsPrint:boolean;
    public CaseTypeEnum = CaseType;

    @ViewChild('relatedPerson') relatedPerson;


    constructor(private dataService: DataService, private route: ActivatedRoute, private router: Router) {
        this.currentUser = JSON.parse(localStorage.getItem("currentUser"));
        //if (this.currentUser.Security.search("vintJAXPortalAccess") >= 0) {
        //    this.currentUser.UserType = 1;
        //} else {
        //    this.currentUser.UserType = 0;
        //}
    }

    public ngOnInit() {
        this.sub = this.route.queryParams.subscribe(params => {
            this.caseNumber = params["CaseNumber"];
            this.caseId = params["CaseID"];
            this.roleId = params["RoleID"];
            this.CaseType = params["CaseType"];
        });
       
        if (this.currentUser.Security.search("vintJAXPortalAccess") >= 0) {
        this.dataService.get("Cases/IsCaseRestricted?caseId=" + this.caseId + "&userId=" + this.currentUser.UserId).subscribe(resp => {
            this.isCaseRestricted = resp;
            if (this.isCaseRestricted) {
                let msg = new ValidationMessage();
                msg.messageType = ValidationMessageType.Error;
                msg.message =
                    "<span class='glyphicon glyphicon-warning-sign' style='color: #73732b'></span>You have been resticted from this case, please see your supervisor if you have any concerns.";
                this.validationMessage = msg;
            } else {
                this.validationMessage = null;
            }
        });
        }

    }

    public canAccess() :boolean {
        if (this.currentUser.UserType == 1 || this.currentUser.UserType==2) {
            if (this.CaseType !== CaseType.JA && this.CaseType !== CaseType.AC) {
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }
    }

    public ngOnDestroy() {
        if (this.sub)
            this.sub.unsubscribe();
    }

   public print(): void {
       this.IsPrint = true;
       this.relatedPerson.print(true);
       setTimeout(() => this.printDocument(), 1000);
    }

    public printDocument() {
        let printContents, popupWin;
        printContents = document.getElementById('print-section').innerHTML;
        popupWin = window.open('', '_blank');
        popupWin.document.open();
        popupWin.document.write(`<html>
        <head>
        <link href="/jax/assets/css/bootstrap.min.css" rel="stylesheet" />
            <link href="/jax/assets/css/Site.css" rel="stylesheet" />
            <link href="/jax/assets/css/print.css" rel="stylesheet" />
            <link href="/jax/assets/css/datatable.css" rel="stylesheet" />
            <link href="/jax/assets/css/dashboard.css" rel="stylesheet" />
          <title>Print tab</title>
          <style>
        </style>
        </head>
        <body>${printContents}</body>
      </html>`
        );

        popupWin.document.close();

        this.IsPrint = false;
        this.relatedPerson.print(false);
    }

    public backtoSearch(){
        if(this.currentUser.UserType!=0){
            this.router.navigate(['./dashboard/searchcase']);
        }
        else{
            this.router.navigate(['./dashboard/mywork']);
        }
    }


}
